"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readingListShareEvent = exports.sendLibraryClickEvent = exports.sendRemoveFromArchiveEvent = exports.sendAddToArchiveEvent = exports.sendRemoveFromLibraryEvent = exports.sendAddToLibraryEvent = void 0;
var _1 = require(".");
/**
 * Sends an event that a story was added to a users library.
 * Event name: "app:library:story:add"
 * @param storyId id of the story that is being added to the users library
 * @param page where the story is added to the library
 */
var sendAddToLibraryEvent = function (storyId, page) {
    if (page === "story_details") {
        (0, _1.sendEvent)("app", "story", "library", "add", {
            storyid: storyId,
            page: page,
        });
    }
    else {
        (0, _1.sendEvent)("app", "library", "story", "add", {
            storyid: storyId,
            page: page,
        });
    }
};
exports.sendAddToLibraryEvent = sendAddToLibraryEvent;
/**
 * Sends an event that a story was removed to a users library.
 * Event name: "wattpad:story:library:remove"
 * @param storyId id of the story that is being removed from the users library
 * @param page where the story is removed to the library
 */
var sendRemoveFromLibraryEvent = function (storyId, page) {
    if (page) {
        (0, _1.sendEvent)("app", "story", "library", "remove", {
            storyid: storyId,
            page: page,
        });
    }
    else {
        (0, _1.sendEvent)("wattpad", "story", "library", "remove", {
            storyid: storyId,
        });
    }
};
exports.sendRemoveFromLibraryEvent = sendRemoveFromLibraryEvent;
/**
 * Sends an event that a story was added to a users archive.
 * Event name: "wattpad:story:archive:add"
 * @param storyId id of the story that is being added to the archive
 */
var sendAddToArchiveEvent = function (storyId) {
    (0, _1.sendEvent)("wattpad", "story", "archive", "add", {
        storyid: storyId,
    });
};
exports.sendAddToArchiveEvent = sendAddToArchiveEvent;
/**
 * Sends an event that a story was removed to a users archive.
 * Event name: "wattpad:story:archive:remove"
 * @param storyId id of the story that is being removed from the archive
 */
var sendRemoveFromArchiveEvent = function (storyId) {
    (0, _1.sendEvent)("wattpad", "story", "archive", "remove", {
        storyid: storyId,
    });
};
exports.sendRemoveFromArchiveEvent = sendRemoveFromArchiveEvent;
/**
 * Sends an event that an element was clicked on the library page.
 * Event name: "app:library:element:click"
 * @param type type of element that was clicked
 * @param page name of the page the element is located on
 */
var sendLibraryClickEvent = function (type, page) {
    (0, _1.sendEvent)("app", "library", "element", "click", { type: type, page: page });
};
exports.sendLibraryClickEvent = sendLibraryClickEvent;
/**
 * Sends an event that a readinglist was shared on a page.
 * Event name: "app:library:reading_list::share"
 * @param reading_listid list id
 * @param channel sharing channel
 */
var readingListShareEvent = function (reading_listid, channel) {
    (0, _1.sendEvent)("library", "reading_list", null, "share", {
        reading_listid: reading_listid,
        channel: channel,
    });
};
exports.readingListShareEvent = readingListShareEvent;
